/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Internal_Code_LabelInputs */

const vi_order_internal_code_label = /** @type {(inputs: Order_Internal_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã đơn nội bộ`)
};

/**

* @param {Order_Internal_Code_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_internal_code_label = /** @type {((inputs?: Order_Internal_Code_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Internal_Code_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_internal_code_label(inputs)
});